import type { QuestionModule } from "../contracts";
import {
  textHighlighterCore,
  type TextHighlighterRaw,
  type TextHighlighterDefinition,
  type TextHighlighterDraft,
  type TextHighlighterEvent,
  type TextHighlighterResponse,
} from "./core";
import { TextHighlighterView } from "./views";

export const textHighlighterModule: QuestionModule<
  TextHighlighterRaw,
  TextHighlighterDefinition,
  TextHighlighterDraft,
  TextHighlighterEvent,
  TextHighlighterResponse
> = {
  type: "text_highlighter",
  galleryFeatures: [
    "baseline",
    "selection",
    "overlap",
    "restored",
    "color",
    "unanswered",
  ],
  core: textHighlighterCore,
  prompt: (definition) => ({
    content: definition.prompt,
    error: definition.error,
  }),
  views: {
    default: {
      id: "default",
      label: "Highlight",
      component: TextHighlighterView,
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action"],
    },
  },
  defaultDisplay: { view: "default" },
  controls: (definition, draft, _display, copy) => ({
    primaryAction: {
      purpose: "submit",
      label: copy.actions.send,
      action: { type: "submit" },
    },
    ...(definition.dontKnow
      ? {
          secondaryAction: {
            label: definition.dontKnow.label,
            selected: draft.dontKnowSelected,
            action: {
              type: "submit" as const,
              event: { type: "toggle-dont-know" as const },
            },
          },
        }
      : {}),
  }),
};
